import { render, staticRenderFns } from "./order-logistics-tracking.vue?vue&type=template&id=5a6426f5&scoped=true&"
import script from "./order-logistics-tracking.vue?vue&type=script&lang=js&"
export * from "./order-logistics-tracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6426f5",
  null
  
)

export default component.exports